"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "12px",
    height: "23px",
    viewBox: "0 0 12 23"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Testing-&-Map-Views",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-3",
    transform: "translate(-15.000000, -12.000000)",
    fill: "#8C8C8C"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "beaker",
    transform: "translate(15.000000, 12.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,10 L4,18.9999798 C4,20.102495 4.89694576,21 6,21 C7.10197184,21 8,20.1026638 8,18.9999798 L8,10 L4,10 Z M10,10 L10,18.9999798 C10,21.2091299 8.20464385,23 6,23 C3.790861,23 2,21.2055487 2,18.9999798 L2,9 L2,10 L10,10 Z",
    id: "Combined-Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5,13 L7,13 L7,18.9970707 C7,19.5509732 6.55613518,20 6,20 L6,20 C5.44771525,20 5,19.5621186 5,18.9970707 L5,13 Z",
    id: "Rectangle-413"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-415",
    x: "0",
    y: "8",
    width: "4",
    height: "2"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-415-Copy",
    x: "8",
    y: "8",
    width: "4",
    height: "2"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval-78",
    cx: "6.5",
    cy: "6.5",
    r: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval-79",
    cx: "10",
    cy: "2",
    r: "2"
  })))));
};

exports["default"] = _default;